<template>
    <div>
        <div class="row">
            <button class="btn btn-primary" @click="addMovimento">Adicionar movimento</button>
            <div class="col-md-12">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" @change="setDeletados" id="filtra-deletados">
                    <label class="form-check-label" for="filtra-deletados">
                        Mostrar Apenas Deletados
                    </label>
                </div>
                <v-table :column="colunas" :data="dataComputed"  :actions="actionsTable" @show='show' @delet="destroy" @edit="recuperar"></v-table>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="modal-estoque" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="form-group">
                                <label>Selecione um Produto</label>
                                <v-select :options="objProduto"  v-model="produto" :disabled="showHistorico"></v-select>
                            </div>
                        </div>
                        <div class="row" v-show="!showHistorico">
                            <div class="form-group">
                                <label>Tipo Movimentação</label>
                                <select v-model="movimentacao" class="form-control">
                                    <option disabled value="">Entrada / Saída</option>
                                    <option value="ENTRADA">Entrada</option>
                                    <option value="SAIDA">Saída</option>
                                </select>
                            </div>
                        </div>
                        <div class="row" v-show="!showHistorico">
                            <div class="form-group">
                                <label>Quantidade</label>
                                <input type="number" v-model="quantidade" class="form-control">
                            </div>
                        </div>
                        <div class="row" v-show="showHistorico">
                            <div class="col-md-12">
                                <table class="table-bordered table-striped table-hover">
                                    <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Movimentação</th>
                                        <th>Produto</th>
                                        <th>Quant.</th>
                                        <th>Usuário</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,i) in tableHistorico" :key="i">
                                        <td>{{ formatDate(item.created_at)}}</td>
                                        <td>{{ item.movimentacao }}</td>
                                        <td>{{ item.produto.codigo }} - {{ item.produto.nome }}</td>
                                        <td>{{ item.quantidade }}</td>
                                        <td>{{ item.usuario.name }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="saveProduto" v-show="!showHistorico">Salvar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AdmEstoque",
        data() {
            return {
                filtrarDeletados: false,
                colunas:[
                    ["Código","codigo"],["Produto","nome"],['Saldo','saldo']
                ],
                tableData:[],
                quantidade: 0,
                movimentacao: '',
                produto: '',
                listaProdutos: [],
                saldo: 0,
                tableHistorico: [],
                showHistorico: false
            }
        },
        methods:{
            formatDate:function(data){
              return moment(data).format('DD/MM/YYYY');
            },
            addMovimento:function(){
                this.clearProduto();
               $('#modal-estoque').modal();
            },
            setDeletados:function(event){
                this.filtrarDeletados = event.target.checked;
                this.loadEstoque();
            },
            recuperar:function(id){
                var vm = this;
                this.$swal({
                    title: 'Realmente deseja recuperar este prodduto de ponta de estoque?',
                    text: 'Ao recuperar, ele irá validar se possui estoque e poderá bloquear pedidos em caso de falta.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim Recuperar!',
                    cancelButtonText: 'Não, Cancelar!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if(result.value) {
                        axios.post('/adm/produtos/estoque/restore',{ id: id }).then(function (response) {
                            var obj = response.data;
                            //vm.filtrarDeletados = false;
                            vm.loadEstoque();
                        }).catch(function (error) {
                            vm.$swal('OPs', error.response.data.errors, 'error');
                            console.log(error);
                        });
                        //this.$swal('Ok', 'You successfully deleted this file', 'success')
                    }
                })
            },
            destroy: function(id){
                var vm = this;
                this.$swal({
                    title: 'Realmente deseja deletar este prodduto de ponta de estoque?',
                    text: 'Se precisar recuperar este produto, basta restaurar produtos deletados...',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim Deletar!',
                    cancelButtonText: 'Não, Cancelar!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if(result.value) {
                        axios.post('/adm/produtos/estoque/delete',{ id: id }).then(function (response) {
                            var obj = response.data;
                            vm.loadEstoque();
                        }).catch(function (error) {
                            vm.$swal('OPs', error.response.data.errors, 'error');
                            console.log(error);
                        });
                        //this.$swal('Ok', 'You successfully deleted this file', 'success')
                    }
                })
            },
            show:function(id){
                var vm = this;
                axios.get('/adm/produtos/estoque',{ params : { id: id }}).then(function(response){
                    let obj = response.data;
                    vm.tableHistorico = obj.historico;
                    vm.produto = {
                        label: obj.produto.codigo + ' - '+ obj.produto.nome,
                        value: obj.produto.id
                    };
                    vm.saldo = obj.saldo_disponivel;
                    vm.showHistorico = true;
                    $('#modal-estoque').modal();
                }).catch(function(error){
                    alert("Falha ao carregar os produtos");
                    $('.loading').hide();
                    console.log(error);
                });
            },
            saveProduto:function(){

                var vm = this;
                if(this.produto === ''){
                    return this.$swal('Ops..', 'Selecione um produto.','error');
                }
                if(this.movimentacao === ''){
                    return this.$swal('Ops..', 'Informe se esta movimentação está Entrando ou saindo do estoque...','error');
                }
                if( parseInt(this.quantidade) <= 0){
                    return this.$swal('Ops..', 'Informe a quantidade que deseja movimentar. Ela não pode ser menor ou igual a zero !','error');
                }
                var data = {
                    produto: this.produto.value,
                    movimentacao: this.movimentacao,
                    quantidade: this.quantidade
                };
                axios.post('/adm/produtos/estoque',data).then(function (response) {
                    console.log(response.data);
                    vm.clearProduto();
                    vm.loadEstoque();
                    $('#modal-estoque').modal('hide');
                }).catch(function(erro){
                    var e = erro.response.data;
                    vm.$swal('OPS',e ? e.errors : erro,'erro');
                })
            },
            loadEstoque:function(){
                var vm = this;
                $('.loading').show();

                axios.get('/adm/produtos/estoque',{ params : { lista: vm.filtrarDeletados ? 'TRASH' : 'TODOS'}}).then(function(response){

                    let produtos = response.data;

                    var data = [];
                    produtos.forEach(function(item){

                        let obj = {
                            id: item.id,
                            codigo: item.produto.codigo,
                            nome: item.produto.nome,
                            saldo: item.saldo_disponivel
                        };
                        data.push(obj);
                    });
                    vm.tableData = data;
                    $('.loading').hide();
                }).catch(function(error){
                    alert("Falha ao carregar os produtos");
                    $('.loading').hide();
                    console.log(error);
                });
            },
            loadProdutos:function () {
                var vm = this;
                $('.loading').show();
                axios.get('/adm/produtos',{ params : { lista: 1}}).then(function(response){

                    //vm.listaProdutos = response.data;
                    let obj = response.data;
                    obj.forEach(function(a){
                       if(a.campanha.indexOf('D') < 0){
                           vm.listaProdutos = a.produtos;
                       }
                    });

                    $('.loading').hide();
                }).catch(function(error){
                    alert("Falha ao carregar os produtos");
                    $('.loading').hide();
                    console.log(error);
                });
            },
            clearProduto:function(){
                this.produto = '';
                this.quantidade = 0;
                this.movimentacao = '';
                this.showHistorico = false
            },
        },
        computed:{
            dataComputed(){
                return this.tableData;
            },
            objProduto(){
                var arrayProdutos = [];
                this.listaProdutos.forEach(function(item){
                    arrayProdutos.push({
                        label: item.codigo +' - '+item.nome,
                        value: item.id
                    })
                });
                return arrayProdutos;
            },
            actionsTable(){

                if(this.filtrarDeletados){
                    return ['show','edit'];
                }else{
                    return ['show','delet'];
                }
            }
        },
        created:function(){
            this.loadProdutos();
            this.loadEstoque();
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/produtos/AdmEstoque.vue